<div class="content-wrapper">
  <div class="header-wrapper w-100-1">
    <h2 class="header-title">
      @if (id) {
        {{ userType }} Account:
        {{ userFullName }}
      } @else {
        Account
      }
    </h2>
    <div class="profile-actions-container">
      @if (profileUser?.isLandowner && isSuperAdmin) {
        @if (!isReadAdmin) {
          <button (click)="navigateSendEmail()" color="primary" mat-stroked-button>
            Send Email
          </button>
        }
        <button (click)="deleteUser()" color="warn" mat-raised-button>Delete User</button>
      }
    </div>
  </div>
  <div class="column">
    @if (!editingProfile && !editingEmail) {
      <div class="card">
        <div class="card-header">
          <span>Profile Information</span>
        </div>
        <div class="card-content">
          <div class="full-name">
            Full Name:
            <span class="value">{{ userFullName }}</span>
            @if (id && !profileUser?.isVerified) {
              @if (profileUser.rejectedBy !== null) {
                <fa-icon [icon]="['far', 'xmark']" class="red size-20" title="Is Denied"></fa-icon>
                <span class="denied">Denied</span>
              }
              @if (isAdmin) {
                <div (click)="verifyAccount()" class="fc-link">Verify User</div>
              }
            } @else {
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Verified"></fa-icon>
              <span class="verified">Verified</span>
            }
          </div>
          @if (id && !profileUser?.isVerified) {
            <div class="not-verified-warning">
              <div class="warning-text">
                <fa-icon [icon]="['far', 'triangle-exclamation']" class="orange size-20"></fa-icon>
                <span>Not Verified By Plaid</span>
              </div>
              @if (profileUser.identityAttempts > 1) {
                <span>
              This user has previously submitted Plaid
                  {{ profileUser.identityAttempts }} times
            </span>
              }
            </div>
          }
          <div>
            Company Name:
            <span class="value">{{ company }}</span>
          </div>
          <div>
            Company Title:
            <span class="value">{{ title }}</span>
          </div>
          <div>
            Email:
            <span class="value">{{ email }}</span>
          </div>
          <div>
            Address:
            <span class="value">{{ streetAddress }}</span>
          </div>
          <div>
            City:
            <span class="value">{{ city }}</span>
          </div>
          <div>
            State:
            <span class="value">{{ state }}</span>
          </div>
          <div>
            Zip:
            <span class="value">{{ zip }}</span>
          </div>
          <div>
            Phone #:
            <span class="value">
            {{ phone }}
              @if (profileUser?.mfaEnabled) {
                <fa-icon [icon]="['fas', 'check']" class="green size-20" title="MFA Enabled"></fa-icon>
                <span class="mfa-enabled">MFA Enabled</span>
              }
          </span>
          </div>
          @if (!this.isReadAdmin) {
            <div class="command">
              <div (click)="toggleProfileEdit()" class="fc-link" data-cy="button-edit-profile">Edit Profile</div>
              <div (click)="toggleEmailEdit()" class="fc-link">Change Email</div>
              @if (this.isAdmin && this.profileUser) {
                @if (this.profileUser.identityProviderId) {
                  <div
                    (click)="openPlaid()"
                    class="fc-link">
                    <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue"></fa-icon>
                    Plaid Submission
                  </div>
                }
                @if (!this.profileUser.identityProviderId) {
                  <div
                    class="warning-text">
                    <fa-icon [icon]="['far', 'triangle-exclamation']" class="orange size-20"></fa-icon>
                    <span>No Plaid Submission Found</span>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    } @else if (editingProfile) {
      <div class="card">
        <div class="card-header">
          <span>Profile Information</span>
        </div>
        <div class="card-content">
          <form [formGroup]="updateProfileForm" fcFormUnloadWarning>
            <input formControlName="address_id" type="hidden" />
            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">First Name</mat-label>
              <input
                data-cy="profile-first-name-input"
                formControlName="firstName"
                id="firstName"
                matInput
                required
                type="text" />
              <mat-error>First Name is Required</mat-error>
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">Last Name</mat-label>
              <input
                data-cy="profile-last-name-input"
                formControlName="lastName"
                id="lastName"
                matInput
                required
                type="text" />
              <mat-error>Last name is required</mat-error>
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">Company Name</mat-label>
              <input data-cy="profile-company-name-input" formControlName="company" id="company" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">Company Title</mat-label>
              <input data-cy="profile-company-title-input" formControlName="title" id="title" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Address 1</mat-label>
              <input
                data-cy="profile-address-1-input"
                formControlName="street"
                id="street"
                matInput
                required
                type="text" />
              <mat-error>Address 1 is required</mat-error>
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Address 2</mat-label>
              <input data-cy="profile-address-2-input" formControlName="street2" id="street2" matInput type="text" />
            </mat-form-field>

            <mat-form-field class="w-100-1">
              <mat-label>City</mat-label>
              <input data-cy="profile-city-input" formControlName="city" id="city" matInput required type="text" />
              <mat-error>City is required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">State</mat-label>
              <mat-select class="state-select" formControlName="state" id="state">
                @for (state of stateList; track state) {
                  <mat-option [value]="state.value">
                    {{ state.viewValue }}
                  </mat-option>
                }
              </mat-select>
              <mat-error>State is required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-50-2">
              <mat-label class="profile-label">Zip</mat-label>
              <input
                class="profile-input"
                data-cy="profile-zip-input"
                formControlName="zip"
                id="zip"
                matInput
                maxlength="5"
                type="text" />
              @if (updateProfileForm?.controls?.zip?.errors?.required) {
                <mat-error>Zip is required</mat-error>
              }
            </mat-form-field>

            <mat-form-field [floatLabel]="getFloatLabelValue()" class="w-100-1">
              <mat-label>Phone #</mat-label>
              <input
                (blur)="formatPhone($event)"
                data-cy="profile-phone-input"
                formControlName="phone"
                id="phone"
                matInput
                placeholder="(XXX) XXX-XXXX"
                type="text" />
            </mat-form-field>
            @if (phoneNumberError) {
              <mat-error>
                This phone number is invalid.
              </mat-error>
            }
            @if (!updateProfileForm.controls.phone.enabled) {
              <mat-hint>** You must disable MFA and/or unsubscribe from SMS Notifications before changing your phone
                number.
              </mat-hint>
            }
            <div class="profile-data mfa-checkbox w-100-1">
              <mat-checkbox (change)="confirmMFA($event)" data-cy="mfa-checkbox" formControlName="mfaEnabled">
                Enable Multi-Factor Authentication
              </mat-checkbox>
            </div>
            <div class="profile-data sms-checkbox w-100-1">
              <mat-checkbox (change)="confirmSMSOptIn($event)" data-cy="sms-checkbox" formControlName="smsOptIn">
                Subscribe to SMS Notifications
              </mat-checkbox>
            </div>
            @if (!updateProfileForm.controls.mfaEnabled.enabled) {
              <mat-hint>** You must save your phone number before enrolling in MFA or SMS Notifications.</mat-hint>
            }
          </form>
          <div class="footer-edit-buttons">
            <button
              (click)="toggleProfileEdit()"
              class="button-margin-right"
              color="primary"
              data-cy="profile-cancel-button"
              mat-stroked-button>
              Cancel
            </button>
            <button
              (click)="updateProfile()"
              [disabled]="!isUpdateProfileFormValid()"
              color="primary"
              data-cy="profile-save-button"
              mat-raised-button>
              Save
            </button>
          </div>
        </div>
      </div>
    } @else {
      <div class="card">
        <div class="card-header">
          <span>Profile Information</span>
        </div>
        <div class="card-content">
          <form [formGroup]="updateEmailForm" fcFormUnloadWarning>
            <mat-form-field class="w-100-1">
              <mat-label>Email</mat-label>
              <input email formControlName="email" id="email" matInput required type="text" />
              <mat-error>{{ profileEmailErrorMessage }}</mat-error>
            </mat-form-field>
          </form>
          <div class="footer-edit-buttons">
            <button (click)="toggleEmailEdit()" color="primary" mat-stroked-button>Cancel</button>
            <button (click)="updateEmail()" [disabled]="!updateEmailForm.valid" color="primary" mat-raised-button>
              Save
            </button>
          </div>
        </div>
      </div>
    }
    @if (!this.isReadAdmin) {
      <div class="card">
        <div class="card-header">Password</div>
        <div class="card-content">
          <div class="command password-command">
            @if (!isAdmin) {
              <a
                [queryParams]="{ mode: authModeEnum.changePassword }"
                [routerLink]="'/auth'"
                class="fc-link">
                Change / Reset Password
              </a>
            } @else {
              <div (click)="sendAdminPasswordReset()" class="fc-link">Change / Reset Password</div>
              <div>{{ resetMessage }}</div>
            }
          </div>
        </div>
      </div>
    }

    @if (profileUser?.isLandowner) {
      <div class="card">
        <div class="card-header">Delegate</div>
        @if (!showAddDelegate) {
          <div class="card-content">
            <div>
              {{ delegateUser ? delegateUser.getDisplayName({ includeEmail: true }) : 'No Delegate Set' }}
            </div>
            @if (!this.isReadAdmin && !this.isAdmin) {
              <div class="command">
                <div (click)="toggleAddDelegateControls(true)" class="fc-link" data-cy="button-change-add-delegate">
                  {{ delegateUser ? 'Change Delegate' : 'Add a Delegate' }}
                </div>
                <div (click)="deleteDelegate()" class="fc-link" data-cy="link-remove-delegate">
                  {{ delegateUser ? 'Remove Delegate' : '' }}
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="card-content">
            <form [formGroup]="createDelegateForm" fcFormUnloadWarning>
              <mat-form-field class="w-100-1">
                <mat-label>Delegate Email</mat-label>
                <input formControlName="delegateEmail" id="delegateEmail" matInput type="email" />
                <mat-error>{{ delegateEmailErrorMessage }}</mat-error>
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>Delegate First Name</mat-label>
                <input formControlName="delegateFirstName" id="delegateFirstName" matInput type="text" />
              </mat-form-field>
              <mat-form-field class="w-100-1">
                <mat-label>Delegate Last Name</mat-label>
                <input formControlName="delegateLastName" id="delegateLastName" matInput type="text" />
              </mat-form-field>
              <div class="legal-disclaimer">
                <mat-checkbox
                  class="delegateTermsClicked"
                  data-cy="delegate-terms-checkbox"
                  formControlName="delegateTermsClicked"
                  id="delegateTermsClicked">
                  By adding a Delegate to your account, you expressly authorize LandYield, its affiliates, and its and
                  their employees, agents, and contractors to disclose information relating to your Site(s) to the
                  Delegate, whether that information is contained on the LandYield website or otherwise. The Delegate
                  will have the ability to view all information related to your Site(s), including scheduled and past
                  payments, other than bank account details (i.e., bank account number and routing number). You will be
                  responsible for signing any final contracts, but the Delegate may make any changes or submissions that
                  are available to you with respect to your Site(s) without your prior consent.
                </mat-checkbox>
              </div>
              @if (error) {
                <span class="small-error-text">
              Unable to add this delegate. Please contact us at
                  {{ helpPhone }} or via email at
              <a href="mailto:{{ helpEmail }}" rel="noopener noreferrer" target="_blank">
                {{ helpEmail }}
              </a>
              for assistance
            </span>
              }
              <div class="footer-edit-buttons">
                <button
                  (click)="toggleAddDelegateControls(false)"
                  class="button-margin-right"
                  color="primary"
                  data-cy="button-cancel"
                  mat-stroked-button>
                  Cancel
                </button>
                <button
                  (click)="onDelegateSubmit()"
                  [disabled]="!createDelegateForm.valid"
                  color="primary"
                  data-cy="button-save-delegate"
                  mat-raised-button>
                  Save Delegate
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    }
  </div>

  @if (profileUser.isLandowner) {
    <div class="column">
      @if (!isReadAdmin) {
        <div class="card">
          <div class="card-header">Payments</div>
          <div class="list-content">
            @if (errorMessage) {
              {{ errorMessage }}
            }
            <div class="no-sites">
              <p>
                Payments will continue provided that reporting is completed on time, disturbances are accurately
                recorded,
                and the property remains in good standing. All payments are securely made through Stripe™.
              </p>
              @if (notificationState?.landOwner.stripeAccountRequiresAction) {
                <p class="error-text">
                  Your Stripe™ account requires action. Please click the button below to resolve issue.
                </p>
              }
              @if (sitesLoaded && !hasActiveSites) {
                <p class="error-text">You don't have any active sites.</p>
              }
              <div class="legal-disclaimer">{{ stripeDisclaimer }}</div>
            </div>
          </div>
          @for (account of configuredStripeAccounts; track account) {
            <div>
              <div class="buyer-group">
                <div (click)="getLoginLink()" class="stripe-set-up fc-link">
                  <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue download-icon"></fa-icon>
                  <span>View Stripe™ Account</span>
                </div>
              </div>
            </div>
          }
          @for (account of unconfiguredStripeAccounts; track account) {
            <div>
              @if (hasActiveSites) {
                <div class="buyer-group">
                  <p class="error-text">
                    Please sign up for a Stripe™ account to start receiving payments and viewing payment history.
                  </p>
                  <div (click)="doStripeConnect()" class="stripe-set-up fc-link">
                    <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" class="blue download-icon"></fa-icon>
                    <span>Set Up A Payment Account</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (profileUser?.landowners.length > 0) {
        <div class="card">
          <div class="card-header">Landowner Access</div>
          <div class="card-content">
            @for (landowner of profileUser.landowners; track landowner) {
              <div>
                <div>
                  Landowner:
                  <span class="value">
              {{ landowner.getDisplayName({ includeEmail: true }) }}
            </span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (isAdmin) {
        <div class="card">
          <div class="card-header">Site List</div>
          <div class="card-content">
            <div class="site-list">
              @for (site of createdSites; track site) {
                <p><span class="value">
              <a href="admin/site/{{ site.id }}" rel="noopener noreferrer" target="_blank">
                {{ site.name }}
              </a> | {{ site.area | number: '1.0-2' }} acres | {{ site.status }}
            </span></p>
              }
            </div>
          </div>
        </div>
      }
      <div class="card">
        <div class="card-header">Recent User Activity</div>
        <div class="card-content">
          <div class="site-list">
            @for (userActivity of userActivityResults; track userActivity.id) {
              <p>{{ userActivity.event }} | {{ userActivity.eventDetails }}
                | {{ userActivity.eventTime | date: 'long' }}</p>
            }
            <button mat-stroked-button color="primary"
                    (click)="router.navigate(isAdmin || isReadAdmin ? ['/admin','user-activity'] : ['/account','profile','activity'], { queryParams: { userId: profileUser.id, selectedUser: profileUser.getDisplayName() } })"
                    data-cy="button-load-more-activity">Load More
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
